import { getAsyncData } from '@support/utils';
import { getCategoryList } from '@support/api';

export async function getCategoryListFn() {
  try {
    await nextTick();
    const { data } = await useAsyncData(() => getCategoryList());
    const options = getAsyncData(data).data;
    return options
  } catch (error: any) {
    error?.msg && showToast(error.msg);
  }

}